import Swiper from "swiper";
import { Autoplay, EffectFade, FreeMode, Navigation, Pagination, Scrollbar, Thumbs } from "swiper/modules";

export const ThumbSlider = () => ({
  mainSwiper: null,
  thumbSwiper: null,

  init() {
    this.thumbSwiper = new Swiper(".swiper-container-thumbs", {
      slidesPerView: 4,
      spaceBetween: 15,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      modules: [FreeMode, Thumbs]
    });

    this.mainSwiper = new Swiper(this.$el, {
      modules: [Autoplay, EffectFade, Navigation, Pagination, Scrollbar, Thumbs],
      spaceBetween: 10,
      loop: true,
      thumbs: {
        swiper: this.thumbSwiper
      }
    });
  }
});
